import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../pages/Index.vue'
import Timelock from "@/pages/Timelock";
import Proposals from "@/pages/Proposals";
import ProposalDetail from "@/pages/ProposalDetail";
import PaymentVaults from "@/pages/PaymentVaults";
import PaymentVaultSingle from "@/pages/PaymentVaultSingle";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/timelock',
    name: 'Timelock',
    component: Timelock
  },
  {
    path: '/proposals',
    name: 'Proposals',
    component: Proposals
  },
  {
    path: '/proposals/:propNumber',
    name: 'ProposalDetail',
    component: ProposalDetail
  },
  {
    path: '/payment-vaults',
    name: 'PaymentVaults',
    component: PaymentVaults
  },
  {
    path: '/payment-vaults/:vaultAddress',
    name: 'PaymentVaultsSingle',
    component: PaymentVaultSingle
  },
  { path: '*', redirect: {name: 'Index'} },
]

const isIPFS = window.location.host.indexOf('k51qzi5uqu5djh7kn7aqel48jmy1zmd8y9faz5jtmcsnrvlcectuo8bu4bhbv0') !== -1
const isFileProtocol = window.location.protocol === 'file:'

const router = new VueRouter({
  mode: (isIPFS || isFileProtocol) ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
